import React from "react";

import ExitToAppTwoToneIcon from '@mui/icons-material/ExitToAppTwoTone';
import CloseIcon from '@mui/icons-material/Close';

const Chart3Detail = (props: any) => {

  // take props
  const taskId = props.taskId;
  const handleClose = props.handleClose;

  // sessions
  const name = localStorage.getItem("nameOfChart3");
  const value = localStorage.getItem("valueOfChart3");

  return (
    <div className="
      flex flex-col bg-white
      lg:w-[35rem] w-screen h-[30rem]
      rounded-md
    ">

      {/* header */}
      <div className="
        flex w-full bg-sky-500 rounded-t-md
        p-12-16 items-center font-semibold text-white
        text-lg justify-between

      ">
        <p>Bảng đánh giá kết quả</p>
        <button
          className="hover:bg-slate-300 p-0.5 rounded-md"
          onClick={handleClose}
        >
          <CloseIcon/>
        </button>
      </div>

      {/* content */}
      <div className="flex flex-col w-full h-[calc(100%-6rem)] overflow-auto p-4 text-sm">
        <p>Tên nhân sự: <span className="font-bold">{name}</span></p>
        <p>Điểm thành tích: <span className="font-bold">{value}</span></p>

        <p className="mt-5">(Cái bảng công việc ở chỗ này này.)</p>
      </div>

      {/* footer */}
      <div className="flex w-full p-12-16 footer  rounded-b-md justify-end items-center text-sm space-x-4">
        <button className="
          flex items-center space-x-1 w-max h-max p-2 bg-slate-300 text-white rounded-md
          hover:bg-slate-200
        "
          onClick={handleClose}
        >
          <ExitToAppTwoToneIcon fontSize="small" />
          <p>Đóng</p>
        </button>
      </div>
    </div>
  )
}

export default Chart3Detail;
